import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Bir şeyler ters gitti";
  // Sanitize raw Pydantic pattern-mismatch messages into a friendlier line.
  const sanitize = (msg) => {
    if (typeof msg !== "string") return msg;
    if (/String should match pattern|value_error|type=[a-z_]+/.test(msg)) {
      return "Bu tür dosya kabul edilmiyor";
    }
    return msg;
  };
  if (typeof detail === "string") return sanitize(detail);
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? sanitize(e.msg) : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return sanitize(detail.msg);
  return String(detail);
}

export default api;
